import React from 'react';
import { observer } from 'mobx-react-lite';
import { Helmet } from 'react-helmet';

import AuctionsHome from '../../components/Dashboard/Auctions/AuctionsHome';

export const Auctions = observer((props) => {
  return (
    <>
      <Helmet>
        <title>Simulcast - Portal</title>
      </Helmet>
      <AuctionsHome
        auctionName={props.location.state?.auctionName}
        AuctionID={props.match.params.auctionID}
      />
    </>
  );
});

export default Auctions;
